/**
 * Chart configuration for the Analytics Overview page.
 */

import { CSAT_TICKS, formatCsatTick, type MetricChartConfig } from '../../utils/chartConfig';

export type MetricKey = 'csat' | 'containment' | 'totalConversations';

export type DurationMetricData = {
  total: string;
  breakdown: { labelKey: string; value: string }[];
};

export const METRIC_CHART_CONFIGS: Record<MetricKey, MetricChartConfig> = {
  csat: {
    dataKey: 'value',
    label: 'analytics.overview_new.avg_ai_csat',
    domain: [0, 5],
    valueFormatter: (value) => value.toFixed(1),
    ticks: CSAT_TICKS,
    tickFormatter: formatCsatTick,
    fill: 'gap',
  },
  containment: {
    dataKey: 'value',
    label: 'analytics.containment',
    domain: [0, 100],
    valueFormatter: (value) => `${value}%`,
    fill: 'gap',
  },
  totalConversations: {
    dataKey: 'value',
    label: 'analytics.total_conversations',
    domain: [0, 'auto'],
    valueFormatter: (value) => value.toLocaleString(),
    fill: 'zero',
  },
};
